import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop — resets scroll to the top of the page on every pathname change.
 *
 * Mount once inside the Router (in App.tsx). It renders nothing; the sole
 * purpose is the side-effect in the useEffect hook.
 *
 * Hash changes within the same pathname are intentionally ignored so that
 * in-page anchor links (e.g. `/privacy#data-retention`) work as expected.
 *
 * @example
 * // In App.tsx:
 * function App() {
 *   return (
 *     <>
 *       <ScrollToTop />
 *       <Routes>...</Routes>
 *     </>
 *   );
 * }
 */
export function ScrollToTop(): null {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
